import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '@/services/api/settings.service';
import type { UpdateSettingsRequest } from '@/types';
import { queryKeys } from './keys';

export function useSettings() {
  return useQuery({
    queryKey: queryKeys.settings.mine(),
    queryFn: ({ signal }) => settingsService.get(signal),
  });
}

/** The server's answer replaces the cache, so the switches show what was saved. */
export function useUpdateSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateSettingsRequest) => settingsService.update(body),
    onSuccess: (settings) => {
      queryClient.setQueryData(queryKeys.settings.mine(), settings);
    },
  });
}
